











import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { getCost } from "@/lib/moneyHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import FormatMoney from "@/components/FormatMoney";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionSubscription",
  components: { FormatMoney, TransactionView },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  computed: {
    opponentName(): string {
      return resolveUserName(this.transaction.details.opponent);
    },
    subscriptionAmount(): number {
      if (!this.transaction.details?.level?.pricePackage) return 0;
      return getCost(this.transaction.details.level.pricePackage);
    },
  },
});
